import { render, staticRenderFns } from "./gruenstrom.vue?vue&type=template&id=23cfa1d6&scoped=true&"
import script from "./gruenstrom.vue?vue&type=script&lang=js&"
export * from "./gruenstrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfa1d6",
  null
  
)

export default component.exports